import classnames from 'classnames';
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import { scrollElementIntoView } from '../../helpers/scroll';

interface IProps {
    value: string;
    placeholder: string;
    isError?: boolean;
    type?: string;
    onChange(event: React.ChangeEvent<any>): void;
    isFirstInvalidFormField?: boolean;
    mask?: any;
    maskPlaceholder?: string;
}

interface IState {
    placeholder: string;
}

export class Input extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            placeholder: this.props.placeholder,
        };
    }

    inputRef = null;
    getInputRef = (ref) => (this.inputRef = ref);

    handleFocus = () => {
        this.setState({ placeholder: this.props.maskPlaceholder || this.props.placeholder });
    };

    handleBlur = () => {
        this.setState({ placeholder: this.props.placeholder });
    };

    shouldComponentUpdate(nextProps: IProps, nextState: IState) {
        return (
            this.props.isError !== nextProps.isError ||
            this.props.isFirstInvalidFormField !== nextProps.isFirstInvalidFormField ||
            this.props.value !== nextProps.value ||
            this.props.placeholder !== nextState.placeholder ||
            this.props.type !== nextProps.type ||
            this.props.mask !== nextProps.mask ||
            this.state.placeholder !== nextState.placeholder ||
            this.props.maskPlaceholder !== nextProps.maskPlaceholder
        );
    }

    componentDidUpdate() {
        if (this.props.isFirstInvalidFormField && this.props.isError) {
            scrollElementIntoView(this.inputRef);
        }
    }

    render() {
        const {
            placeholder,
            isError,
            value,
            onChange,
            mask,
            maskPlaceholder,
            type = 'text',
        } = this.props;

        const inputClassName = classnames('contact-input', { 'input-error': isError });
        return (
            <div ref={this.getInputRef}>
                {mask ? (
                    <MaskedInput
                        type={type}
                        className={inputClassName}
                        value={value}
                        placeholder={this.state.placeholder}
                        onChange={onChange}
                        onFocus={maskPlaceholder ? this.handleFocus : null}
                        onBlur={maskPlaceholder ? this.handleBlur : null}
                        mask={mask}
                    />
                ) : (
                    <input
                        className={inputClassName}
                        type={type}
                        value={value}
                        placeholder={placeholder}
                        onChange={onChange}
                    />
                )}
            </div>
        );
    }
}
